import { cx } from '@linaria/core';
import { memo } from 'react';
import "./Progress.linaria.module.css!=!./Progress?./Progress.linaria.module.css?css=H4sIAAAAAAAAA3VRW46jMBD831MgrVaaSAPCYB5hD2MZbIeeGNvxA0LQ3H2UbAjJaOfH7XZVV7u7EuoHMhxJnw3DR7kY7cCDVo3lknoY+d/PX8mVcnQEFeNpmuyiR26F1FPTA2NcrYxxJki7k87GZQLm+wal6Z8V5BlBM8ZaiqXncOh9g815BfeOoCD5WbQLA2cknZtW6u644hkjKFSdOM3f0qWl3fFgdVAs7rTUthmpfYtjY2Ggdo7ltdNulUFlJfe5IM6rqa4jZ6ja5qWt0zL4x7xozFlpFAFmxAH/I0sufJOuDJp3xaV7IXhtNjzr88x9vOCt9l4PG+XiGW0DQWN5KZFfOZZxG1vKILim2raEqtpmQAlq63Sow72jpeo+we0qtB2iNMlcJEFxah/F4kwnGUgoK4Hcf57uzb/v87cQ4smGPcYw96/ZTyYwSyduYwYjMG4fLhhyYsKYaqEKBnr7ueSUgTpEWYJc1IUWurjlF+D2LU3K4j1KkxrdQpXfQr4vdhEoAQo2wwzB9Zx2T7LeUpA/6aK7ML6eGL9HaBehBBXuWfgLxgkZZR0DAAA="
const progressStyles = "atm_mk_h2mmj6 atm_ks_15vqwwr atm_vy_1osqo2v atm_e2_1y44olf atm_9s_1ulexfb atm_2d_1u7cfqy atm_167l93f_stnw88 atm_1v3d6pn_idpfg4 atm_a3c5zc_idpfg4 atm_2h32sj_idpfg4 atm_ztdabu_1v6z61t atm_178r2ia_1b80m8u atm_1fxawlu_u67f1s";
const invertedColors = "atm_2d_944iyh";
const leadingStyles = "atm_p_qdfpp7";
const trailingStyles = "atm_p_48y0c";
type ProgressProps = {
  invert?: boolean;
};
const Progress = ({
  invert
}: ProgressProps) =>
// <LinearProgress css={invert ? invertedColors : null} />
<span className={cx(progressStyles, invert ? invertedColors : null)}>
        <span className={leadingStyles}></span>
        <span className={trailingStyles}></span>
    </span>;
export default memo(Progress);